export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

export function validateEmails(list) {
  // list: array of strings
  const valid = [];
  const invalid = [];
  list.forEach(e => {
    const trimmed = e.trim().toLowerCase();
    if (isValidEmail(trimmed)) valid.push(trimmed);
    else if (trimmed) invalid.push(trimmed);
  });
  return { valid, invalid };
}
